/**
 * Called when the $location does not match any route
 */
/* @ngInject */
export function OtherwiseCtrl($location, $window, PageStore) {
  if (!PageStore.isInitialPage()) {
    let base = $window.$("base").attr("href") || "/";
    if (base.match(/^\/admin\//)) {
      $window.location.href = $location.absUrl();
    } else {
      $window.location.href = $location.url();
    }
  }
}
